import Vue from 'vue';

export const generateAnonymousTokenRequest = async ({ session, token }) => {
  return Vue.axios.post(`/generate-token/${session}`, {
    token,
  });
};
